import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="login-terminal">
      <div className="terminal-scanlines"></div>

      <div className="terminal-header">
        <div className="terminal-logo">KOMOK</div>
        <div className="terminal-subtitle">TERMS, CONDITIONS & CRISES</div>
      </div>

      <div className="terminal-window">
        <div className="terminal-title-bar">
          <span className="terminal-title">LEGAL DEPARTMENT</span>
          <div className="terminal-dots">
            <span className="dot red"></span>
            <span className="dot yellow"></span>
            <span className="dot green"></span>
          </div>
        </div>

        <div className="terminal-content" style={{ padding: '20px', textAlign: 'center' }}>
          <div style={{ marginBottom: '20px' }}>
            <img
              src="/cy-legal.jpg"
              alt="Cy - KOMOK Chief Legal Officer"
              style={{
                width: '180px',
                height: '180px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '3px solid #3fb950',
                display: 'block',
                margin: '0 auto',
              }}
            />
            <div style={{
              color: '#3fb950',
              fontSize: '14px',
              fontFamily: 'monospace',
              marginTop: '10px',
              fontWeight: 'bold',
            }}>
              CY
            </div>
            <div style={{
              color: '#8b949e',
              fontSize: '11px',
              fontFamily: 'monospace',
            }}>
              Chief Legal Officer & Head of Compliance
            </div>
          </div>

          <div style={{
            textAlign: 'left',
            color: '#c9d1d9',
            fontSize: '13px',
            fontFamily: 'monospace',
            lineHeight: '1.8',
            padding: '16px',
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid #333',
            borderRadius: '6px',
            marginBottom: '20px',
          }}>
            <div style={{ color: '#3fb950', fontWeight: 'bold', marginBottom: '12px', fontSize: '14px' }}>
              KOMOK TERMS, CONDITIONS & CRISES
            </div>

            <p style={{ marginBottom: '12px' }}>
              By registering for KOMOK, you solemnly swear (or affirm, we're not picky) the following:
            </p>

            <p style={{ marginBottom: '10px', color: '#f0883e' }}>
              1. ASSUMPTION OF RISK & GENERAL CHAOS
            </p>
            <p style={{ marginBottom: '12px', paddingLeft: '16px' }}>
              You acknowledge that KOMOK is a high-intensity, competitive, and occasionally
              ridiculous event. You voluntarily assume full responsibility for your own time,
              health, wellbeing, and fun while participating. This includes but is not limited to:
              sore losers, paper cuts from trading cards, emotional damage from market crashes,
              existential dread from bad investments, and any crises (financial or otherwise) that
              may arise during gameplay.
            </p>

            <p style={{ marginBottom: '10px', color: '#f0883e' }}>
              2. WAIVER OF LIABILITY
            </p>
            <p style={{ marginBottom: '12px', paddingLeft: '16px' }}>
              KOMOK, its organizers, affiliates, mascots (including but not limited to Cy, pictured
              above), and all associated parties shall not be held liable for any damages, injuries,
              health effects, hurt feelings, bruised egos, or portfolio losses sustained during
              the event. You cannot sue us. Cy will not testify.
            </p>

            <p style={{ marginBottom: '10px', color: '#f0883e' }}>
              3. INTELLECTUAL PROPERTY & TRADE SECRETS
            </p>
            <p style={{ marginBottom: '12px', paddingLeft: '16px' }}>
              All insider information obtained during KOMOK stays at KOMOK. What happens
              on the trading floor stays on the trading floor.
            </p>

            <p style={{ marginBottom: '10px', color: '#f0883e' }}>
              4. DISPUTE RESOLUTION
            </p>
            <p style={{ marginBottom: '12px', paddingLeft: '16px' }}>
              All disputes shall be settled via a game of Battleship. Cy's decision is final
              and binding in all matters.
            </p>

            <p style={{ color: '#8b949e', fontStyle: 'italic', fontSize: '11px', marginTop: '16px' }}>
              By clicking "I Agree" during registration, you confirm that you have read, understood,
              and accepted these terms. You also confirm that Cy is adorable.
            </p>
          </div>

          <button
            className="login-button"
            onClick={() => navigate(-1)}
            style={{ maxWidth: '300px', margin: '0 auto' }}
          >
            GOT IT
          </button>
        </div>
      </div>

      <div className="terminal-tagline">
        "Your productivity is our profit"
      </div>
    </div>
  );
};

export default TermsPage;
